<mat-card>
  <mat-card-title data-at-note-modal-title>
    {{ (isEditNote ? 'NOTE_MODAL.EDIT_NOTE_TITLE' : 'NOTE_MODAL.ADD_NOTE_TITLE') | translate }}
  </mat-card-title>
  <mat-card-content class="!flex flex-col">
    <mat-form-field mat-textarea>
      <textarea
        data-at-note-modal-input
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        [value]="note ? note : ''"
        (input)="newNote = getValue($event)"
        cdkAutosizeMaxRows="3"
        gtm="onTextField"
        gtmId="note"
        gtmAction="Note"
        gtmCategory="noteModal"
        [gtmOn]="['change', 'focus', 'blur']"
      ></textarea>
    </mat-form-field>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-note-modal-cancel-btn
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="noteModal"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-note-modal-confirm-btn
      [disabled]="!newNote"
      mat-raised-button
      color="primary"
      gtm="onSave"
      gtmAction="Note"
      gtmCategory="noteModal"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
